import { createAction } from '@reduxjs/toolkit';

interface ActionsOpened {
  type: string;
}

export const ACTIONS_OPENED = 'moreButton/ACTIONS_OPENED';

export const actionsOpened = createAction<ActionsOpened>(ACTIONS_OPENED);
